import React from "react";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CleanUser, GetUserByemail } from "../../store/auth-store/auth-actions";
import { userActions } from "../../store/auth-store/auth-slice";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import UserFormDetail from "../Forms/UserFormDetail";
import { getTokenInfo } from "../../utils/Guard";
import Loading from "../loading/Loading";
import styles from "../../components/Forms/UserFormDetail.module.css";

const DialogModal = (props) => {
  const userInfo = getTokenInfo();
  const [searchEmail, setSearchEmail] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      props.searchEmail !== undefined &&
      props.searchEmail !== "" &&
      searchEmail === ""
    ) {
      setSearchEmail(props.searchEmail);
      dispatch(GetUserByemail(props.searchEmail, userInfo.Email, []));
    }
  }, [dispatch, props.searchEmail, searchEmail, userInfo.Email]);

  const footerContent = (
    <>
      {props.refresh === false && (
        <div className="">
          <Button
            text
            raised
            type="button"
            label="Guardar"
            onClick={() => {
              props.addUserHandler();
            }}
            className={styles.saveButton}
          />
          {/* <Button
            text
            raised
            label="Cancelar"
            onClick={() => cancelHanlder()}
            className={styles.cardBackButton}
          /> */}
        </div>
      )}
    </>
  );

  const content = (
    <>
      {props.refresh === true && (
        <>
          <Loading />
        </>
      )}
      {props.refresh === false && <UserFormDetail isCreation={true} />}
    </>
  );

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header={props.header}
        visible={props.visible}
        onHide={() => props.setVisible(false)}
        footer={footerContent}
        position="center"
        style={{padding: "0px"}}
      >
        {content}
      </Dialog>
    </div>
  );
};
export default DialogModal;
